import { useState } from "react";

import {
  ButtonBase,
  ClickAwayListener,
  Tooltip,
  useMediaQuery,
  type TooltipProps
} from "@mui/material";

import { radius, spacing } from "@/src/theme/tokens";

export interface InfoTooltipProps extends Omit<
  TooltipProps,
  "open" | "onClose"
> {
  children: TooltipProps["children"];
  ariaLabel?: string;
}

const InfoTooltip = ({ children, ariaLabel, ...rest }: InfoTooltipProps) => {
  const isTouch = useMediaQuery("(hover: none)");
  const [open, setOpen] = useState(false);

  const trigger = (
    <ButtonBase
      aria-label={ariaLabel}
      onClick={(event) => {
        if (!isTouch) return;
        event.stopPropagation();
        setOpen((prev) => !prev);
      }}
      sx={{ display: "inline-flex", p: spacing.xs, borderRadius: radius.xs }}
    >
      {children}
    </ButtonBase>
  );

  if (!isTouch) {
    return (
      <Tooltip arrow {...rest}>
        {trigger}
      </Tooltip>
    );
  }

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        arrow
        open={open}
        onClose={() => setOpen(false)}
        disableHoverListener
        disableTouchListener
        {...rest}
      >
        {trigger}
      </Tooltip>
    </ClickAwayListener>
  );
};

export default InfoTooltip;
